export default __webpack_public_path__ + "static/media/pixar.4ec7e04a.png";